import { normalizeProvince } from '@/app/lib/seo/performanceSeoPackage'

/** Minúsculas y sin tildes, para comparar el título con la provincia. */
function fold(text: string): string {
  return text
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
}

/**
 * Título del evento con su provincia: «{title} en {provincia}» (FR-008).
 *
 * Se devuelve `title` tal cual cuando la provincia falta o está vacía, o cuando
 * el propio título ya la contiene (sin distinguir mayúsculas ni tildes).
 *
 * Solo para lo que muestra la ficha y su analítica: el paquete SEO y las migas
 * siguen usando `title` a secas porque su patrón ya incorpora la provincia.
 */
export function buildPerformanceTitle(
  title: string,
  province: string | null | undefined,
): string {
  const normalized = normalizeProvince(province)
  if (!normalized) return title
  if (fold(title).includes(fold(normalized))) return title
  return `${title} en ${normalized}`
}
